import createReducer from '../utils/createReducer';
import actions from '../actions/vatInformation';
import {getSelectOptions} from '../components/utils/addressUtil';
import {checkingVatInfoBtnStatus} from '../utils/validate';
import {getAlteredVatRegions} from '../utils/commonUtil';
import StabAddressFormConfigurator from '@homeaway/stab-address-form-configurator';

const initialState = {};

const actionHandlers = {
    [actions.GET_VAT_METADATA_SUCCESS](state, {payload}) {
        const billingSetupUserMeta = payload.billingSetupUserMeta;
        let companyCountryCode;

        if (billingSetupUserMeta) {
            companyCountryCode = billingSetupUserMeta.companyCountryCode;
            payload.vatMetadata.userInformation.companyCountryCode = companyCountryCode;
        } else {
            companyCountryCode = payload.vatMetadata.userInformation.companyCountryCode;
        }

        const countryList = payload.vatMetadata.countryList;
        payload.vatMetadata.companyCountryInfo = countryList instanceof Array ? countryList.find((e) => e.countryCode === companyCountryCode) : null;

        return {
            ...state,
            vatMetadata: payload.vatMetadata,
        };
    },

    [actions.SET_VAT_FIELD](state, {payload}) {
        switch (payload.fieldName) {
            case 'Vat Information Country': return {
                ...state,
                vatInformationCountry: payload.fieldValue
            };

            case 'Vat Number': return {
                ...state,
                vatNumber: payload.fieldValue
            };

            case 'Vat Region Code': return {
                ...state,
                vatRegionCode: payload.fieldValue
            };

            case 'Vat Address Country': return {
                ...state,
                vatAddressCountry: payload.fieldValue,
                vatStateSelect: '',
                vatState: ''
            };

            case 'Vat Address Line1': return {
                ...state,
                vatAddressLine1: payload.fieldValue
            };

            case 'Vat Address Line2': return {
                ...state,
                vatAddressLine2: payload.fieldValue
            };

            case 'Vat City': return {
                ...state,
                vatCity: payload.fieldValue
            };

            case 'Vat Select State': return {
                ...state,
                vatStateSelect: payload.fieldValue,
                vatState: ''
            };

            case 'Vat State': return {
                ...state,
                vatState: payload.fieldValue,
                vatStateSelect: ''
            };

            case 'Vat Postal Code': return {
                ...state,
                vatPostalCode: payload.fieldValue
            };
            default: return {
                ...state
            };
        }
    },

    [actions.SET_FIELD_ERROR](state, {payload}) {
        switch (payload.field) {
            case 'Vat.InformationCountry': return {
                ...state,
                vatInfoCountryError: payload.msg
            };
            case 'Vat.Number': return {
                ...state,
                vatNumberError: payload.msg
            };
            case 'country': return {
                ...state,
                vatAddressCountryError: payload.msg
            };
            case 'address1': return {
                ...state,
                vatAddressLine1Error: payload.msg
            };
            case 'city': return {
                ...state,
                vatCityError: payload.msg
            };
            case 'stateProvince': return {
                ...state,
                StateError: payload.msg
            };
            case 'postalCode': return {
                ...state,
                vatPostalCodeError: payload.msg
            };
            default: return {
                ...state
            };
        }
    },

    [actions.GET_VAT_REGION_CODE](state, {payload}) {
        const vatRegionCodeList = payload.regionCodeList;
        let vatRegionCodeOptions = [];

        if (vatRegionCodeList) {
            for (const vatCountry of vatRegionCodeList) {
                if (vatCountry.countryCode === payload.selectedCountry) {
                    getAlteredVatRegions(vatCountry);
                    vatRegionCodeOptions = getSelectOptions(vatCountry.specialRegion);
                    break;
                }
            }
        }

        return {
            ...state,
            vatRegionCodeOptions,
        };
    },

    [actions.ENABLE_VAT_CONTINUE_BUTTON](state, {}) {
        return {
            ...state,
            enableContinueButton: checkingVatInfoBtnStatus(state)
        };
    },

    [actions.INFO_ICON_CLICKED](state, {payload}) {
        return {
            ...state,
            infoIconClickedStatus: payload.infoIconClickedStatus
        };
    },

    [actions.VAT_SERVICE_ERROR](state, {payload}) {
        return {
            ...state,
            serviceError: payload.errorKey
        };
    },

    [actions.PRE_POPULATE_VAT_FROM_BILLING_SETUP_METADATA](state, {payload}) {
        let newState = {...state};

        if (payload.vatMeta && payload.vatMeta.vatNumber && !payload.vatMeta.vatNumber.startsWith('TID')) {
            const vatMeta = payload.vatMeta;

            newState = {
                ...newState,
                vatNumber: vatMeta.vatNumber,
                vatAddressCountry: vatMeta.country,
                vatAddressLine1: vatMeta.address1,
                vatAddressLine2: vatMeta.address2,
                vatCity: vatMeta.city,
                vatPostalCode: vatMeta.postalCode
            };

            if (vatMeta.regionCode) {
                newState = {
                    ...newState,
                    vatRegionCode: vatMeta.regionCode
                };
            }

            if (vatMeta.stateProvince) {
                // Check if country has a list of states/provinces
                if (StabAddressFormConfigurator.getRegions(vatMeta.country)) {
                    newState = {
                        ...newState,
                        vatStateSelect: vatMeta.stateProvince
                    };
                } else {
                    newState = {
                        ...newState,
                        vatState: vatMeta.stateProvince
                    };
                }
            }
        }

        return {
            ...newState,
            enableContinueButton: checkingVatInfoBtnStatus(newState),
        };
    }
};

export default createReducer(actionHandlers, initialState);
